import { useSelector } from 'react-redux';

export const useLocaleCountry = () =>
    useSelector((state) => state.user?.activeBusiness?.localeData?.country);
